module.exports = __webpack_public_path__ + "img/img-2.d13ce9ed.png";